import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 4H2.5C2.30109 4 2.11032 4.07902 1.96967 4.21967C1.82902 4.36032 1.75 4.55109 1.75 4.75V13.5C1.75 13.6989 1.82902 13.8897 1.96967 14.0303C2.11032 14.171 2.30109 14.25 2.5 14.25H11.25C11.4489 14.25 11.6397 14.171 11.7803 14.0303C11.921 13.8897 12 13.6989 12 13.5V4.75C12 4.55109 11.921 4.36032 11.7803 4.21967C11.6397 4.07902 11.4489 4 11.25 4ZM10.5 12.75H3.25V5.5H10.5V12.75ZM14.25 2.5V11.25C14.25 11.4489 14.171 11.6397 14.0303 11.7803C13.8897 11.921 13.6989 12 13.5 12C13.3011 12 13.1103 11.921 12.9697 11.7803C12.829 11.6397 12.75 11.4489 12.75 11.25V3.25H4.75C4.55109 3.25 4.36032 3.17098 4.21967 3.03033C4.07902 2.88968 4 2.69891 4 2.5C4 2.30109 4.07902 2.11032 4.21967 1.96967C4.36032 1.82902 4.55109 1.75 4.75 1.75H13.5C13.6989 1.75 13.8897 1.82902 14.0303 1.96967C14.171 2.11032 14.25 2.30109 14.25 2.5Z",
		fill: "currentColor"
	})
});
export default SvgCopy;
